import { useEffect } from 'react'
import { ensureG2OfficialRatingSchema } from '../../lib/g2OfficialRatingSchema'

/** Loads G2’s official rating_schema.json JSON-LD (same as the G2 badge embed). */
export function G2ReviewsJsonLd() {
  useEffect(() => {
    ensureG2OfficialRatingSchema()
  }, [])
  return null
}
